import React, { useState, useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Select } from "antd";
import "./index.css";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { programsList } from "../../../../Store/actions/programs";
import america from "../../../../Utils/location/america";

const ProgramSearch = () => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [cities, setCities] = useState([]);
  const [minDiscount, setMinDiscount] = useState("");
  const [budget, setBudget] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const onFocusInput = (e) => (e.currentTarget.type = "date");
  const onBlurInput = (e) => (e.currentTarget.type = "text");

  const states = Object.keys(america);

  useEffect(() => {
    if (state) return setCities(america[state]);
    setCities([]);
  }, [state]);

  const onSubmit = (e) => {
    e.preventDefault();

    const start = new Date(startDate);
    const end = new Date(endDate);

    let data = {
      budget,
      minDiscount,
      state,
      city,
      startDate: start,
      endDate: end,
      limit: 8,
    };

    dispatch(programsList(data));
  };

  return (
    <section className="program-search-container" form={onSubmit}>
      <div className="d-flex h-100" style={{ alignItems: "stretch" }}>
        <input
          type="number"
          className="form-control"
          placeholder="Min Discount"
          aria-label="search"
          aria-describedby="basic-addon1"
          value={minDiscount}
          onChange={(e) => setMinDiscount(e.target.value)}
        />
        <input
          type="number"
          className="form-control"
          placeholder="Budget"
          aria-label="search"
          aria-describedby="basic-addon1"
          value={budget}
          onChange={(e) => setBudget(e.target.value)}
        />
        <input
          type="text"
          className="form-control"
          placeholder="Created From"
          aria-label="search"
          onFocus={onFocusInput}
          onBlur={onBlurInput}
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <input
          type="text"
          className="form-control"
          placeholder="To"
          aria-label="search"
          onFocus={onFocusInput}
          onBlur={onBlurInput}
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />

        <div style={{ width: "100%", height: "100%" }}>
          <Select
            style={{
              width: "100%",
              minHeight: "100%",
              border: "1px solid rgb(206, 212, 218)",
              display: "flex",
              alignItems: "center",
            }}
            showArrow={false}
            bordered={false}
            onChange={(value) => setState(value)}
            placeholder="State"
          >
            {states.map((state) => (
              <Option key={state} value={state} style={{ width: "200px" }}>
                {state}{" "}
              </Option>
            ))}
          </Select>
        </div>

        <div
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <Select
            style={{
              width: "100%",
              minHeight: "100%",
              border: "1px solid rgb(206, 212, 218)",
              display: "flex",
              alignItems: "center",
            }}
            showArrow={false}
            bordered={false}
            onChange={(value) => setCity(value)}
            placeholder="City"
          >
            {cities.map((city, index) => (
              <Option key={index} value={city}>
                {city}
              </Option>
            ))}
          </Select>
        </div>

        <div
          className="search-link-btn"
          style={{ width: "50%", height: "100%" }}
        >
          <Link
            to={`programs-list/?minDiscount=${minDiscount}&city=${city}&state=${state}&budget=${budget}&startDate=${startDate}&endDate=${endDate}`}
          >
            <button type="submit" className="search-button">
              <SearchOutlined style={{ color: "#000", fontSize: "1.2rem" }} />
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProgramSearch;
